import { defineComponent as _defineComponent } from 'vue'
import type {
  YagiChatQuestion,
  YagiChatQuickReply
} from '@/utils/format-edit/yagiChatBot'


export default /*#__PURE__*/_defineComponent({
  __name: 'YagiChatBotInputArea',
  props: {
    aiResultMode: { type: Boolean },
    thinkingMode: { type: Boolean },
    isLoadingCompanyInfo: { type: Boolean },
    currentQuestionIndex: null,
    questionsLength: null,
    allQuestionsCompleted: { type: Boolean },
    currentQuestion: null,
    currentAnswer: null,
    showUsageCount: { type: Boolean },
    usageCount: null,
    maxUsageCount: null,
    usageCountLabel: null,
    completeButtonText: null
  },
  emits: ["update:currentAnswer", "skip-url", "submit-url", "submit", "submit-none", "quick-reply", "enter", "composition", "complete"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:currentAnswer', value: string): void
  (e: 'skip-url'): void
  (e: 'submit-url'): void
  (e: 'submit'): void
  (e: 'submit-none'): void
  (e: 'quick-reply', reply: YagiChatQuickReply): void
  (e: 'enter', event: KeyboardEvent): void
  (e: 'composition', value: boolean): void
  (e: 'complete'): void
}), expose: any, slots: any, attrs: any }) {





function onAnswerInput(event: Event) {
  const target = event.target as HTMLInputElement
  emit('update:currentAnswer', target.value)
}

return { __sfc: true,emit, onAnswerInput }
}

})